<template>
  <div v-loading="loading">
    <el-table
      class="pareto-table"
      v-if="tableConfig"
      :key="tableKey"
      :data="pareto"
      style="width: 100%"
      row-key="id"
      border
      @sort-change="handleSortChange"
    >
      <component
        :is="column.value"
        v-for="column in tableConfig.columns"
        :key="column.value"
      />
    </el-table>
  </div>
</template>

<script>
  import Actions from './Actions';
  import TableSettings from '../../TableSettings';
  import columns, { allColumns, labels } from './columns';

  export default {
    components: {
      Actions,
      TableSettings,
      ...columns,
    },
    props: {
      defaultFilterString: String
    },
    data() {
      return {
        labels,
        allColumns,
        tableKey: 0,
        itemLoading: 0,
        currentSort: {
          prop: 'gross_price',
          order: 'desc',
        },
      };
    },
    computed: {
      pareto() {
        return this.$store.getters['pareto/pareto'];
      },
      tableConfig() {
        return JSON.parse(JSON.stringify(this.$store.getters['pareto/tableConfig']));
      },
      loading() {
        return this.$store.getters['pareto/loading'];
      },
    },
    watch: {
      tableConfig() {
        this.tableKey++;
      },
    },
    async mounted() {
      this.$store.commit('pareto/setFilterString', '');
      this.$store.commit('pareto/setFilterString', this.defaultFilterString);
      this.$store.commit('pareto/setSorting', this.currentSort);
      await this.$store.dispatch('pareto/fetchAll');
    },
    methods: {
      handleSortChange({ column, prop, order }) {
        if (column.sortable === 'custom') {
          this.$store.commit('pareto/setSorting', { prop, order });
          this.$store.dispatch('pareto/fetchAll');
        }
      },
      getSum(params) {
        let result = [];
        let netSum = 0;
        let grossSum = 0;
        params.data.forEach(pareto => {
          netSum += pareto.net_sum;
          grossSum += pareto.gross_sum;
        });
        result = params.columns.map((column, index) => {
          if(index === 0) {
            return 'Össz.:';
          }
          if(column.property === 'net_sum') {
            return this.$options.filters.currency(netSum.toFixed(2));
          }
          if(column.property === 'gross_sum') {
            return this.$options.filters.currency(grossSum.toFixed(2));
          }
          return '';
        });
        return result;
      },
    },
  };
</script>
<style lang="scss">
  .pareto-table {
    .el-table__footer {
      td {
        .cell {
          font-weight: 700;
        }
      }
    }
  }
</style>
